const setHealthPlanTasks = (state, tasks) => {
  const healthPlanTasks = state.healthPlanTasks || {}
  const keys = Object.keys(tasks)

  for (const key of keys) {
    healthPlanTasks[key] = tasks[key]
  }

  state.healthPlanTasks = healthPlanTasks
}

const setTaskCounters = (state, counters) => {
  Object.assign(state, { counters })
}

const setFilter = (state, filter) => {
  state.selectedFilters[filter.filterType] = filter.filterValue
}
const clearFilters = state => {
  Object.assign(state, {
    selectedFilters: {
      status: [],
      group: [],
      type: state.selectedFilters.type,
      releasedBy: [],
      demand: []
    }
  })
}

export default {
  clearFilters,
  setTaskCounters,
  setFilter,
  setHealthPlanTasks
}
